import { MutableRefObject, useEffect, useRef } from 'react'

/**
 * Returns a monotonically increasing request generation that is invalidated on unmount.
 * Async completions can compare their captured value with the current value before mutating
 * shared state.
 */
export const useUnmountInvalidatedGeneration = (): MutableRefObject<number> => {
  const generationRef = useRef(0)

  useEffect(
    () => () => {
      generationRef.current += 1
    },
    []
  )

  return generationRef
}
